function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.803,
    height: 23.227,
    viewBox: "0 0 29.803 23.227",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1",
    d: "M12.269 5.854h3.587a.431.431 0 0 1 .43.43v14.36a.431.431 0 0 1-.43.43h-3.995l.011-1.583a4.7 4.7 0 0 1-1.522 1.431 4.2 4.2 0 0 1-2.176.548 7.9 7.9 0 0 1-3.182-.641 8.294 8.294 0 0 1-2.6-1.766 8.191 8.191 0 0 1-1.761-2.607A8.064 8.064 0 0 1 0 13.267a7.729 7.729 0 0 1 2.267-5.541 7.958 7.958 0 0 1 2.49-1.689 7.554 7.554 0 0 1 3.036-.609 5.288 5.288 0 0 1 2.519.593 7.224 7.224 0 0 1 1.956 1.507zm-4.2 11.582A3.422 3.422 0 0 0 9.94 16.9a3.831 3.831 0 0 0 1.324-1.439 4.374 4.374 0 0 0 0-4.012 3.848 3.848 0 0 0-1.324-1.426 3.433 3.433 0 0 0-1.873-.532 3.528 3.528 0 0 0-1.9.532 3.891 3.891 0 0 0-1.357 1.439 4.061 4.061 0 0 0-.5 2 4.018 4.018 0 0 0 .51 2A3.966 3.966 0 0 0 6.18 16.9a3.493 3.493 0 0 0 1.887.532",
    transform: "translate(0 1.756)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 2",
    d: "M13.938 22.4V.431A.43.43 0 0 1 14.367 0h3.341a.43.43 0 0 1 .43.431V22.4a.429.429 0 0 1-.43.43h-3.341a.429.429 0 0 1-.429-.43",
    transform: "translate(4.509)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 3",
    d: "M19.182 22.4V.431a.431.431 0 0 1 .43-.431h3.341a.43.43 0 0 1 .43.431V22.4a.429.429 0 0 1-.43.43h-3.341a.43.43 0 0 1-.43-.43",
    transform: "translate(6.206)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoShort);
export default __webpack_public_path__ + "static/media/logo_short.152ebc65576fc4921c04fcaf7f957b77.svg";
export { ForwardRef as ReactComponent };